import { Component, OnInit } from '@angular/core';
import { DatasetModel } from '../../share/models/dataset-model.model';
import { ApiService } from '../../share/services/api.service';
import { AngularSlickgridModule, Column, Filters, Formatters, GridOption, MultipleSelectOption } from 'angular-slickgrid';
import { FieldType } from 'angular-slickgrid';
import FetrapiEnums from "../../share/enum/enums";
import { SharedModule } from '../../share/shared.module';
import { TextExportService } from '@slickgrid-universal/text-export';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.css'],
  imports: [SharedModule, AngularSlickgridModule]
})
export class ConfirmationComponent implements OnInit {
  datasets: DatasetModel[] | undefined = undefined;;
  isLoaded = false;
  isRunningConfirmation = false;
  columnDefinitions: Column[] = [];
  gridOptions: GridOption = {};
  dataset: DatasetModel[] = [];
  numberofrows: number = 100;

  constructor(private api: ApiService) { }

  ngOnInit(): void {

    this.loadDatasets();
  }

  ngAfterViewInit() {
  }

  loadDatasets() {
    this.gridOptions = {
      enableGridMenu: true,
      enableSorting: true,
      enableFiltering: true,
      enableHeaderButton: true,
      enableHeaderMenu: true,
      forceFitColumns: true,
      autoResize: {
        container: '#grid-container', // container DOM selector
      },
      enableAutoResize: true,
      enablePagination: true,
      rowHeight: 42,
      pagination: {
        pageSizes: [5, 10, 15, 20, 25, 50, 75, this.numberofrows],
        pageSize: 10,
      },
      enableTextExport: true,
      textExportOptions: {
        exportWithFormatter: true,
      },
      externalResources: [new TextExportService()],
      gridMenu: {
        hideExportCsvCommand: false,
        hideExportTextDelimitedCommand: false,
        hideExportExcelCommand: false,
        hideClearAllSortingCommand: false,
        hideForceFitButton: false,
        onBeforeMenuShow: (a, b) => {},
      },
    };

    // Helper
    const StringIsAlphanumerical = (value: string) => isNaN(Number(value)) === true;
    this.api.getDataSets(
      '"' + FetrapiEnums.DatasetType.Grid + '", "' + FetrapiEnums.DatasetType.ZoI + '"'
      ,
      '"' + FetrapiEnums.DatasetStatusCode.ValidationSucceeded + '", "' + FetrapiEnums.DatasetStatusCode.MemberApproved + '", "' + FetrapiEnums.DatasetStatusCode.ConfirmationRequired + '"').subscribe({
      next: (data: any) => {
        this.datasets = data;
        if (this.datasets) {
          console.log("results found: " + this.datasets.length);

          this.numberofrows = 0;
          this.datasets.forEach(element => {
            element.id = element.datasetId;
            element.dateTimeCreated = new Date(element.dateTimeCreated);
            this.numberofrows++;
          });
          this.gridOptions.pagination = {
            pageSize: 10,
            pageSizes: [5, 10, 15, 20, 25, 50, 75, this.numberofrows]
          };

          //console.log(data);
          this.isLoaded = true;

          this.dataset = this.datasets;

          // fill the dataset with your data
          //this.dataset = this.getProductionDatasets;

          // var DatasetTypes = [...new Set(data.map(item => item.datasetType))].sort();
          // var StatusCodes = [...new Set(data.map(item => item.statusCode))].sort();
          // var MemberList = [...new Set(data.map(item => item.memberName))].sort();
          // var MemberGroup = [...new Set(data.map(item => item.memberOf))].sort();
          var DatasetTypes = [...new Set(this.dataset.map(item => item.datasetType))].sort();
          var StatusCodes = [...new Set(this.dataset.map(item => item.statusCode))].sort();
          var MemberList = [...new Set(this.dataset.map(item => item.memberName))].sort();
          // TODO waarom bestaat item.memberOf niet ? voorlopig gemapped op memberName om voort te kunnen
          var MemberGroup = [...new Set(this.dataset.map(item => item.memberName))].sort();

          // TODO as unknown as MultipleSelectOption lijkt een gekke oplossing
          this.columnDefinitions = [
            { id: 'MemberName', name: 'MemberName', field: 'memberName', sortable: true, filterable: true, type: FieldType.string, filter: { collection: Object.values(MemberList).filter(StringIsAlphanumerical).map(k => ({ value: `${k}`, label: `${k}` })), model: Filters['multipleSelect'], filterOptions: { offsetLeft: 14 } as unknown as MultipleSelectOption, placeholder: 'Filter on Member' } },
            { id: 'MemberGroup', name: 'MemberGroup', field: 'memberOf', sortable: true, filterable: true, type: FieldType.string, filter: { collection: Object.values(MemberGroup).filter(StringIsAlphanumerical).map(k => ({ value: `${k}`, label: `${k}` })), model: Filters['multipleSelect'], filterOptions: { offsetLeft: 14 } as unknown as MultipleSelectOption, placeholder: 'Filter on Member Group' } },
            { id: 'datasetType', name: 'datasetType', field: 'datasetType', sortable: true, filterable: true, type: FieldType.string, filter: { collection: Object.values(DatasetTypes).map(k => ({ value: `${k}`, label: `${k}` })), model: Filters['multipleSelect'], filterOptions: { offsetLeft: 14 } as unknown as MultipleSelectOption, placeholder: 'Filter on Dataset Type' } },
            { id: 'statusCode', name: 'statusCode', field: 'statusCode', filterable: true, sortable: true, type: FieldType.string, filter: { collection: Object.values(StatusCodes).filter(StringIsAlphanumerical).map(k => ({ value: `${k}`, label: `${k}` })), model: Filters['multipleSelect'], filterOptions: { offsetLeft: 14 } as unknown as MultipleSelectOption, placeholder: 'Filter on log type' } },
            { id: 'dateTimeCreated', name: 'Submitted', field: 'dateTimeCreated', filterable: true, sortable: true, formatter: Formatters['dateTimeEuro'], type: FieldType.dateTimeEuro, outputType: FieldType.dateTimeEuro, filter: { model: Filters['dateRange'] } },
            { id: 'id', name: 'Dataset ID', field: 'id', sortable: true, filterable: true, type: FieldType.string }
          ];
        }
      }
    })
  }

  async requestConfirmation() {
    console.log('requestConfirmation');
    this.isRunningConfirmation = true;
    this.api.requestConfirmation().subscribe({
      next: (data: any) => {
        this.isRunningConfirmation = false;
        this.loadDatasets();
        console.log('requestConfirmation back');
      },
      error: (error:any) => {
          this.api.errorhandler(error);
          this.isRunningConfirmation = false;
          this.loadDatasets();
          console.log('requestConfirmation error');
      }
    });
  }

}
